import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3784ad27"
import script from "./Home.js?vue&type=script&lang=js&external"
export * from "./Home.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotMainHeader: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Organisms/MainHeader/MainHeader.vue').default,HotHeaderSidebar: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Organisms/HeaderSidebar/HeaderSidebar.vue').default,HotHero: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Organisms/Hero/Hero.vue').default,HotFreeCourses: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Organisms/FreeCourses/FreeCourses.vue').default,HotHomeBanner: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Organisms/HomeBanner/HomeBanner.vue').default,HotFooter: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Organisms/Footer/Footer.vue').default})
